export { PunchupHeroCard, PunchupHeroAccent } from "./PunchupHeroCard";
export type { PunchupHeroCardProps } from "./PunchupHeroCard";
